export const container = `px-6 pt-6 pb-px lg:p-6 bg-gray-150/40`;

export const title = `
  text-primary-100 text-2xl font-semibold leading-7
  mb-2 lg:mb-2.5
`;

export const text = `
  text-base-black font-normal
  leading-5 lg:leading-6
  text-sm lg:text-lg
`;
